export function getComponentOption(component: Element, optionName: string) {
  const option = optionName.startsWith('data')
    ? optionName
    : `data-${optionName}`;
  return component.getAttribute(option);
}

export function isComponentOptionEnabled(
  component: Element,
  optionName: string
) {
  const optionValue = getComponentOption(component, optionName);
  return optionValue === 'true';
}

export function getElement<T extends Element>(
  element: string,
  parent?: Element | null
): T {
  const wrap = parent || document;
  return wrap.querySelector(element) as T;
}

export function getButton(element: string, parent?: Element | null) {
  return getElement<HTMLButtonElement>(element, parent);
}

export function getDiv(element: string, parent?: Element | null) {
  return getElement<HTMLDivElement>(element, parent);
}

export function getInput(element: string, parent?: Element | null) {
  return getElement<HTMLInputElement>(element, parent);
}

export function getValue(element: string, parent?: Element | null) {
  return getInput(element, parent).value;
}

export function getNodeList<T extends Element>(
  element: string,
  parent?: Element
) {
  const wrap = parent || document;
  return wrap.querySelectorAll(element) as NodeListOf<T>;
}

export function getArrayFromNodeList<T extends Node>(element: NodeListOf<T>) {
  return Array.from(element);
}
